import {
	Component,
	OnInit,
	OnChanges,
	AfterViewInit,
	ElementRef,
	ViewChild,
	Renderer2,
	ViewChildren,
	QueryList,
} from '@angular/core';
import Chart from 'chart.js/auto';
import { ChartJSWidgetComponent } from '../chart-js-widget.component';
import { v4 as uuidv4 } from 'uuid';
import { debounceTime, fromEvent, throttleTime } from 'rxjs';

@Component({
	selector: 'app-chart-js-barchart',
	templateUrl: './chart-js-barchart.component.html',
	styleUrls: ['./chart-js-barchart.component.scss'],
})
export class ChartJSBarchartComponent
	
	implements OnInit, OnChanges, AfterViewInit
{
	// canvas: any;
	// context: any;
	chartId : string = uuidv4().replaceAll("-", "");
	@ViewChild('chartTarget', {static : true }) chartTarget: ElementRef;	

	private domElement: HTMLElement;

	chart: any;
	rect : { width : string; height : string } = { width : "100%", height : "100%" };

	constructor(private renderer: Renderer2, private elementRef: ElementRef) {
		this.domElement = this.elementRef.nativeElement as HTMLElement;	
		
		fromEvent(window, "resize")
		  .pipe(throttleTime(500), debounceTime(500))
		  .subscribe(() => this.calculateSize());	
	}

	ngOnChanges() {}

	ngOnInit(): void {
		setTimeout(this.createChart, 1000);	
	}

	ngAfterViewInit() : void {
		this.calculateSize();
		this.createChart();
	}

	private calculateSize = () => {				
		if(this.domElement)
		{
			const parentRect = this.domElement?.parentElement?.parentElement?.getBoundingClientRect();
			if(parentRect)
			{
				this.rect = { width : parentRect?.width + "px", height : parentRect?.height + "px" };
				this.renderer.setStyle(this.domElement, "height", `${this.rect.height}`);
				this.renderer.setStyle(this.domElement, "width", `${this.rect.width}`);
			}			
		}
	}

	private createChart = (): void => {
		const canvas = this.chartTarget?.nativeElement;
		//const canvas = this.renderer.createElement("canvas");
		if(!canvas)
		{
			return;
		}

		const context = canvas.getContext("2d");
		
		if(canvas)
		{
			this.renderer.appendChild(this.domElement, canvas);
		}
		this.chart = (new Chart(this.chartTarget?.nativeElement, {
		  type: 'bar', 
	
		  data: {
			labels: ['2022-05-10', '2022-05-11', '2022-05-12','2022-05-13',
									 '2022-05-14', '2022-05-15', '2022-05-16','2022-05-17', ], 
			   datasets: [
			  {
				label: "Sales",
				data: ['467','576', '572', '79', '92',
									 '574', '573', '576'],
				backgroundColor: 'blue'
			  },
			  {
				label: "Profit",
				data: ['542', '542', '536', '327', '17',
										 '0.00', '538', '541'],
				backgroundColor: 'limegreen'
			  }  
			]
		  },
		  options: {
			// aspectRatio:2.5,
			responsive: true
		  }
		  
		}));
		this.chart.canvas.parentNode.style.height = this.rect?.width;
		this.chart.canvas.parentNode.style.width = this.rect?.width;
	}
}
